var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from 'app/core/api/api.js';
import { setAllTasks } from './tasks';
import { setAllTakes } from './takes';
import { setAllRelTakesFlags } from './takesFlags';
import { updateDataFromCollection } from './utils';
import { setAllPostBoardNotes } from './reduxPostBoardNotes';
import { setAllRelAssetLinks } from './reduxAssetLinks';
import { setAllDynamicApprovalValues } from './reduxDynamicApprovalValues';
import { setAllFlags } from './reduxFlags';
import { setAllReduxRelAssetFlags } from './reduxAssetFlags';
import { setAllMedias } from './reduxMedias';
import { setAllTakeValidationMedias } from './reduxTakeValidationMedias';
import { setAllTakeRefMedias } from './reduxTakeRefMedias';
import { setAllPostBoardLinks } from './reduxPostboardLinks';
import { setStateKey } from './stateKey';
const initialState = {
    data: [],
    followUp: [],
    links: [],
    loading: false,
    count: 0,
    httpProgress: 0,
    stats: [],
    statsIsLoading: false,
};
const removeDuplicates = (data, key) => {
    return [...new Map(data.map((x) => [key(x), x])).values()];
};
export const fetchAssets = createAsyncThunk('reduxAssets/fetchAll', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ id, trackingSchemaId, columns, queries = {} }, { fulfillWithValue, rejectWithValue, dispatch }) {
    try {
        const response = yield api.assets.descendantWithTrackingDatas({ id, trackingSchemaId }, Object.assign({ ordering: 'name', columns: columns && columns.length ? JSON.stringify(columns) : undefined, statMode: 'datasOnly' }, queries), {}, (progress) => {
            dispatch(setHttpProgress(progress));
        });
        const results = response.results;
        const tasks = results.flatMap((asset) => asset.tasksInst).filter((_) => _);
        const takes = tasks.flatMap((task) => task.takesInst).filter((_) => _);
        const rel_takeFlagsInst = takes.flatMap((take) => take.rel_takeFlagsInst).filter((_) => _);
        const takesFlagsInst = takes.flatMap((take) => take.flagsInst).filter((_) => _);
        const assetLinksInst = results.flatMap((asset) => asset.linksInst).filter((_) => _);
        const rel_assetLinksInst = results.flatMap((asset) => asset.rel_assetLinksInst).filter((_) => _);
        const postBoardNotes = results
            .flatMap((asset) => { var _a; return (_a = asset.postBoardLinksInst) === null || _a === void 0 ? void 0 : _a.flatMap((link) => link === null || link === void 0 ? void 0 : link.notesInst); })
            .filter((_) => _);
        const postBoardlinksInst = results.flatMap((asset) => asset.postBoardLinksInst).filter((_) => _);
        const dynamicApprovalValuesInst = results.flatMap((asset) => asset.dynamicApprovalValuesInst).filter((_) => _);
        const assetFlagsInst = results.flatMap((asset) => asset.flagsInst).filter((_) => _);
        const rel_assetFlagsInst = results.flatMap((asset) => asset.rel_assetFlagsInst).filter((_) => _);
        const thumbnailInst = results.flatMap((asset) => asset.thumbnailInst).filter((_) => _);
        const rel_takeRefMediasInst = takes.flatMap((take) => take.rel_takeRefMediasInst).filter((_) => _);
        const rel_takeValidationMediasInst = takes.flatMap((take) => take.rel_takeValidationMediasInst).filter((_) => _);
        const validationMediasInst = takes.flatMap((take) => take.validationMediasInst).filter((_) => _);
        const refMediasInst = takes.flatMap((take) => take.refMediasInst).filter((_) => _);
        dispatch(setAllTasks(tasks));
        dispatch(setAllTakes(takes));
        dispatch(setAllRelTakesFlags(rel_takeFlagsInst));
        dispatch(setLinksInst(assetLinksInst));
        dispatch(setAllPostBoardNotes(postBoardNotes));
        dispatch(setAllPostBoardLinks(postBoardlinksInst));
        dispatch(setAllRelAssetLinks(rel_assetLinksInst));
        dispatch(setAllDynamicApprovalValues(dynamicApprovalValuesInst));
        dispatch(setAllFlags([...assetFlagsInst, ...takesFlagsInst]));
        dispatch(setAllMedias([...thumbnailInst, ...validationMediasInst, ...refMediasInst]));
        dispatch(setAllReduxRelAssetFlags(rel_assetFlagsInst));
        dispatch(setAllTakeValidationMedias(rel_takeValidationMediasInst));
        dispatch(setAllTakeRefMedias(rel_takeRefMediasInst));
        dispatch(setStateKey('assets'));
        return fulfillWithValue(response);
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
export const fetchAllAssetsStats = createAsyncThunk('reduxAssetsStats/fetchAll', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ id, trackingSchemaId, queries = {} }, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.assets.descendantWithTrackingDatas({ id, trackingSchemaId }, Object.assign({ statMode: 'statsOnly' }, queries));
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const updateAsset = createAsyncThunk('reduxAssets/update', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ updatedAsset, params = {} }, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.assets.update(updatedAsset, {}, params === null || params === void 0 ? void 0 : params.headers);
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const updateFUAsset = createAsyncThunk('reduxAssets/updateFUAsset', (toUpdate_1, _a) => __awaiter(void 0, [toUpdate_1, _a], void 0, function* (toUpdate, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.assets.collection.update(toUpdate);
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
// actions for middleware
export const updateAssetAction = updateFUAsset.fulfilled;
const { actions, reducer } = createSlice({
    name: 'reduxAssets',
    initialState,
    reducers: {
        updateAssetFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const newData = state.followUp.map((asset) => {
                if (asset.id === updatedPayload.id) {
                    return Object.assign(Object.assign({}, asset), updatedPayload);
                }
                return asset;
            });
            state.followUp = newData;
        },
        setAssetsFromTasks: (state, { payload }) => {
            const t = [...state.data, ...payload];
            const newData = removeDuplicates(t, (it) => it.id);
            state.data = newData;
        },
        setLinksInst: (state, { payload }) => {
            state.links = payload;
        },
        addLinkFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const t = [...state.links, updatedPayload];
            const newData = removeDuplicates(t, (it) => it.id);
            state.links = newData;
        },
        resetFollowUpAssets: (state) => {
            state.followUp = [];
        },
        setHttpProgress: (state, { payload }) => {
            state.httpProgress = payload;
        },
    },
    extraReducers: (builder) => {
        // FETCH ASSETS
        builder.addCase(fetchAssets.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(fetchAssets.fulfilled, (state, { payload }) => {
            const t = [...state.data, ...payload.results];
            const newData = removeDuplicates(t, (it) => it.id);
            state.data = newData;
            state.followUp = payload.results;
            state.count = payload.count;
            state.httpProgress = 0;
            state.loading = false;
        });
        builder.addCase(fetchAssets.rejected, (state, action) => {
            state.loading = false;
        });
        // FETCH ASSETS STATS
        builder.addCase(fetchAllAssetsStats.pending, (state, action) => {
            state.statsIsLoading = true;
        });
        builder.addCase(fetchAllAssetsStats.fulfilled, (state, { payload }) => {
            state.stats = payload.stats;
            state.statsIsLoading = false;
        });
        builder.addCase(fetchAllAssetsStats.rejected, (state, action) => {
            state.statsIsLoading = false;
        });
        // UPDATE ASSET
        builder.addCase(updateAsset.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(updateAsset.fulfilled, (state, { payload }) => {
            // const newData = updateDataFromCollection(state.data, payload)
            const newData = state.data.map((asset) => {
                if (asset.id === payload.id) {
                    return payload;
                }
                return asset;
            });
            state.data = newData;
        });
        builder.addCase(updateAsset.rejected, (state, { payload }) => {
            state.loading = false;
        });
        // DELETE ASSET
        builder.addCase(updateFUAsset.pending, (state) => { });
        builder.addCase(updateFUAsset.fulfilled, (state, { payload }) => {
            const newData = updateDataFromCollection(state.followUp, payload);
            state.followUp = newData;
        });
        builder.addCase(updateFUAsset.rejected, (state, { payload }) => {
            state.loading = false;
        });
    },
});
export const { setAssetsFromTasks, setHttpProgress, resetFollowUpAssets, setLinksInst, updateAssetFromWS, addLinkFromWS, } = actions;
export default reducer;
